import { Box } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CallIcon from '@mui/icons-material/Call';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import useDisplayDate from "../../hooks/Date/useDisplayDate";
import { formatTime } from '../../hooks/Time/formatTime';


const useLoanColumns = () => {
  const { formatDate } = useDisplayDate();


  return [
    
    { accessorKey: 'loanID', header: 'Loan ID' },
    { accessorKey: 'leadID', header: 'Lead ID' },
    { accessorKey: 'loanNo', header: 'Loan Number',size: 200 },
    { accessorKey: 'customerID', header: 'Customer ID',size: 200 },
    {
      accessorKey: 'disbursalAmount',
      header: 'Disbursal Amount',
      accessorFn: (row) => {
        const value = row?.disbursalAmount;
        const isNumeric = !isNaN(value) && value !== null && value !== '';
        return(
          <Box display="flex" alignItems="center">
                    {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                    {value}
          </Box>
        )
        
    },
    size: 220

    },
    {
      accessorKey: 'disbursalDate',
      header: 'Disbursal Date',
      accessorFn: row => formatDate(row?.disbursalDate),
      size: 200
    },
    { accessorKey: 'disbursalTime', header: 'Disbursal Time',size: 200,accessorFn: row => formatTime(row?.disbursalTime), },
    { accessorKey: 'disbursalRefrenceNo', header: 'Disbursal Reference No',size: 280 },
    { accessorKey: 'accountNo', header: 'Account Number',size: 250 },
    { accessorKey: 'accountType', header: 'Account Type',size: 220 },
    { accessorKey: 'bankIfsc', header: 'Bank IFSC' },
    { accessorKey: 'bank', header: 'Bank Name' },
    { accessorKey: 'bankBranch', header: 'Bank Branch',size: 200 },
    { accessorKey: 'chequeDetails', header: 'Cheque Details',size: 200 },
    {
      accessorKey: 'pdDate',
      header: 'PD Date',
      accessorFn: row => formatDate(row.pdDate)
    },
    { accessorKey: 'pdDoneBy', header: 'PD Done By' },
    {
      accessorKey: 'deduction',
      header: 'Deduction',
      accessorFn: (row) => (
        <Box display="flex" alignItems="center">
          <CurrencyRupeeIcon color="secondary" />
          {row.deduction}
        </Box>
      )
    },
    { accessorKey: 'remarks', header: 'Remarks' },
    { accessorKey: 'status', header: 'Status' },
    { accessorKey: 'rejReason', header: 'Rejection Reason',size: 220 },
    { accessorKey: 'companyAccountNo', header: 'Company Account No',size: 250 },
    { accessorKey: 'ip', header: 'IP Address' },
    { accessorKey: 'disbursedBy', header: 'Disbursed By (ID)',size: 230 },
    {
      accessorKey: 'createdDate',
      header: 'Created Date',
      accessorFn: row => formatDate(row.createdDate),
      size: 200
    },
    {
      accessorKey: 'allocate_date',
      header: 'Allocate Date',
      accessorFn: row => formatDate(row.allocate_date),
      size: 200
    },
    { accessorKey: 'allocated_by', header: 'Allocated By',size: 200 },


  ];
};

export default useLoanColumns;
